import { render, staticRenderFns } from "./DeferralRateErrorList.vue?vue&type=template&id=b5335df0&"
import script from "./DeferralRateErrorList.vue?vue&type=script&lang=js&"
export * from "./DeferralRateErrorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports